import {Dispatch} from "redux";

import {IFetchContext} from "@pg-mono/data-fetcher";
import {isEmpty} from "@pg-mono/nodash";

import {IRPRequestMeta} from "../../../app/rp_request_meta";
import {fetchSelectedRegionBySlug} from "../../list/actions/offer_list_selected_data_actions";
import {getCountryId} from "../../list/helpers/sub_type/get_fetch_offer_list_subfilter_query";
import {getOfferListsDefaultDistance} from "../../list/utils/get_offer_lists_default_distance";
import {fetchSearchParsedOnError} from "../searches/fetch_search";
import {fromParsedObjectToQuery, ISlugParsed, ISlugQuery, offerUrlParser} from "./offer_url_parser";

export const parseFriendlyUrl =
    (ctx: IFetchContext<IRPRequestMeta>) =>
    async (dispatch: Dispatch): Promise<Partial<ISlugQuery> | false> => {
        const slugParsed: Partial<ISlugParsed> | null = offerUrlParser(ctx.match.params.friendlySlug, ctx.match.params.offerListSubFilter);

        const country = ctx.match?.params?.country ? getCountryId(ctx.match?.params?.country) : undefined;
        // Pass country to slugParsed if the country comes from an abroad URL
        if (country && slugParsed) {
            slugParsed.country = country;
        }
        if (slugParsed === null || isEmpty(slugParsed)) {
            // not valid slug - return search
            // not parsed properly
            return await getSearchQueryOnError(ctx, dispatch);
        }

        const region = slugParsed.region || ctx.match?.params?.abroadRegionSlug;
        // fetch region id when defined in slug
        const regionData = await convertRegionToQuery(ctx, dispatch, region, country);
        slugParsed.distance = regionData?.distance;

        // cannot find proper region - return search
        if (slugParsed.region && !regionData?.id) {
            return await getSearchQueryOnError(ctx, dispatch);
        }

        if (regionData?.id) {
            // region found, we need id
            slugParsed.region = [regionData?.id.toString()];
            slugParsed.region_name = Array.isArray(region) ? region[0] : region;
        }
        //pass country to be able to do redirect on old abroad listings urls
        if (regionData?.country && !country) {
            slugParsed.country = regionData.country;
        }

        // prepare full query (with strings)
        const slugQuery = slugParsed ? fromParsedObjectToQuery(slugParsed) : {};
        return {...ctx.route.query, ...slugQuery};
    };

async function getSearchQueryOnError(ctx: IFetchContext<IRPRequestMeta>, dispatch: Dispatch) {
    const searchQuery = await dispatch(fetchSearchParsedOnError(ctx));
    return searchQuery === null ? false : {...ctx.route.query, ...searchQuery};
}

async function convertRegionToQuery(ctx: IFetchContext<IRPRequestMeta>, dispatch: Dispatch, parsedRegion?: string, country?: number) {
    if (!parsedRegion) {
        return null;
    }

    const fetchedRegion = await dispatch(fetchSelectedRegionBySlug(ctx.meta, parsedRegion, country));

    if (fetchedRegion === null || fetchedRegion.id === null) {
        return null;
    }

    if (ctx.route?.query?.distance === "" && ctx.prevRoute?.query?.distance !== "") {
        // if distance is empty in current route, but not empty in previous route, we use previous route distance
        return {id: fetchedRegion.id, country: fetchedRegion.country, distance: Number(ctx.prevRoute?.query.distance)};
    }

    return {id: fetchedRegion.id, country: fetchedRegion.country, distance: getOfferListsDefaultDistance(fetchedRegion.type)};
}
